// src/store/slices/statusSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ballotStatus: [],
  requestStatus: [],
  openPositionStatus: [],
  committeeStatus: [],
  recordStatus: []
};

const statusSlice = createSlice({
  name: "statusData",
  initialState,
  reducers: {
    setStatusData: (state, action) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { setStatusData } = statusSlice.actions;
export default statusSlice.reducer;
